import React from 'react'
import { useAppContext } from '../../context/AppContext'

function StatusMessages() {
  const { state } = useAppContext()

  if (!state.statusMessages.length) {
    return null
  }

  return (
    <div id="status-messages" className="status-messages">
      {state.statusMessages.map((messageObj, index) => {
        // Handle both old string format and new object format
        const message = typeof messageObj === 'string' ? messageObj : messageObj.message
        const type = typeof messageObj === 'object' ? messageObj.type : 'info'
        const timestamp = typeof messageObj === 'object' ? messageObj.timestamp : Date.now()
        
        return (
          <div 
            key={timestamp || index} 
            className={`status-message ${type}`}
            style={{
              top: `${20 + index * 60}px`,
              right: '20px',
              position: 'fixed',
              zIndex: 10000
            }}
          >
            <i className={`fas fa-${type === 'success' ? 'check-circle' : type === 'error' ? 'exclamation-circle' : 'info-circle'}`}></i>
            {message}
          </div>
        )
      })}
    </div>
  )
}

export default StatusMessages
